'use strict';

var FilterClassGridFilterFactory = function FilterClassGridFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['FlightDateRangeFilterFactory', 'FlightLevelFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function FilterClassGridFilter() {
    DemandFilter.call(this, 'class', 'class-flight-analysis');
    this.registerFilters(injectedFilters);
  }
  FilterClassGridFilter.constructor = FilterClassGridFilter;
  FilterClassGridFilter.prototype = Object.create(DemandFilter.prototype);
  return FilterClassGridFilter;
};
FilterClassGridFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = FilterClassGridFilterFactory;